module.exports = __webpack_public_path__ + "static/media/RetailerHome-01.b010b1dd.png";